<template>
  <div class="buyerInformationMobile">
    <div class="buyerInformationMobile-head">
      <div class="buyerInformationMobile-head-content">
        <div class="buyerInformationMobile-head-title">
          买家信息表单
        </div>
        <div class="buyerInformationMobile-head-orderNum">
          订单编号：{{ order_no }}
        </div>
      </div>
      <div class="logo"></div>
    </div>
    <div class="buyerInformationMobile-body">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="ruleForm">
        <div class="buyerInformationMobile-body-card" style="padding: 10px 10px 12px 10px;">
          <div class="buyerInformationMobile-body-card-form" style="margin: 0">
            <el-form-item label="选择证明文件" prop="sign_type">
              <template>
                <div class="optionsList" style="flex-wrap: nowrap;justify-content: space-between">
                  <div class="options filetypeOptions" :class="ruleForm.sign_type === item.value ? 'optionsSelect' : ''"
                       v-for="(item,index) in accSourceList" :key="index"
                       @click="ruleForm.sign_type = item.value,resetInfo">
                    {{ item.label }}
                  </div>
                </div>
              </template>
            </el-form-item>

            <div class="sign-tip" v-show="ruleForm.sign_type" @click="ruleForm.sign_type == 2 ? signVisible = true : quitVisible = true">
              {{ ruleForm.sign_type == 2 ? '包赔证明示范图' : '交易合同示范图' }}
              <i class="el-icon-arrow-right"></i>
            </div>

          </div>
        </div>
        <div class="buyerInformationMobile-body-card">
          <div class="buyerInformationMobile-body-card-title agencyInfo">
            <div>{{ ruleForm.sign_type == 1 ? '签约人信息' : '本人信息' }}</div>
            <div class="buyerInformationMobile-body-card-title-tip" style="color: #999999;">
              <i class="el-icon-warning"></i>
              签署电子合同需保证实名，且需年满18周岁
            </div>
            <div class="addParty" @click="editPartyOpen('')" v-show="partyData.length < 6" v-if="ruleForm.sign_type == 1">
              新增
            </div>
          </div>
          <template v-if="ruleForm.sign_type == 2">
            <div class="buyerInformationMobile-body-card-form">
              <el-form-item label="姓名" prop="name">
                <el-input
                  placeholder="请输入姓名"
                  v-model="ruleForm.name"
                  maxlength="10"
                  @keydown.enter.native.prevent="()=>{}"
                ></el-input>
              </el-form-item>
              <el-form-item label="电话号码" prop="phone">
                <el-input
                  placeholder="请输入电话号码"
                  v-model="ruleForm.phone"
                  @keydown.enter.native.prevent="()=>{}"
                ></el-input>
              </el-form-item>
            </div>
          </template>
          <template v-else-if="ruleForm.sign_type == 1">
            <ContractingPartyMobile :countryList="countryList" :partyData="partyData" @handleActive="handleActive"
                                    @refreshData="getSignatoryList()" @open="editPartyOpen"></ContractingPartyMobile>
            <el-form-item v-if="ruleForm.acc_source == 5" label="上传凭证" prop="acc_source">
              <div class="uploadimg-box">
                <div class="uploadimg-box-btn">
                  <el-upload
                    class="upload-box"
                    v-loading="loadingback"
                    action
                    :auto-upload="false"
                    list-type="picture-card"
                    :show-file-list="false"
                    :on-change="uploadCardBehind">
                    <img v-if="ruleForm.acc_source_img" :src="ruleForm.acc_source_img" class="uploadimg-img">
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    <div class="delete" v-if="ruleForm.acc_source_img">
                      <i @click.stop="delAccImg" class="el-icon-delete"></i>
                    </div>
                  </el-upload>
                </div>
                <div class="uploadimg-box-text">
                  外卖、网购订单截图，<span>收货人信息需和签约人一致，且订单日期需在6个月以内</span>，限bmp，jpg，png，jpeg图片格式，不超过5m
                </div>
              </div>
            </el-form-item>
          </template>
        </div>
      </el-form>
    </div>
    <div class="buyerInformationMobile-foot">
      <!-- <button class="buyerInformationMobile-foot-resBtn" v-prevent-re-click @click="resetInfo">
        重填
      </button> -->
      <button class="buyerInformationMobile-foot-subBtn" v-prevent-re-click @click="saveInfo">
        提交
      </button>
    </div>

    <div class="editPartyDialog" v-show="editPartyShow">
      <div class="editPartyDialog-card" id='card'>
        <div class="editPartyDialog-card-head">
          <div class="title" @click="editPartyOpen('')">
            {{ editPartyForm.id ? '修改' : '添加' }}签约信息
          </div>
          <div class="close" @click="editPartyClose">
            <i class="el-icon-close"></i>
          </div>
        </div>
        <div class="editPartyDialog-card-body">
          <el-form
            :model="editPartyForm"
            label-position="left"
            :rules="editPartyRules"
            ref="editPartyForm"
          >
            <el-form-item label="身份信息" prop="name" class="identityInfo">
              <div class="identityInfo-box">
                <el-form-item prop="name" class="identityInfo-box-item">
                  <div class="identityInfo-box-item-label">姓名</div>
                  <el-input size="small" :disabled="!!editPartyForm.id" class="w-298" @keydown.enter.native.prevent="()=>{}" v-model="editPartyForm.name" placeholder="请输入名字" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item prop="cardid" class="identityInfo-box-item">
                  <div class="identityInfo-box-item-label">身份证号</div>
                  <el-input size="small" :disabled="!!editPartyForm.id" class="w-298" @keydown.enter.native.prevent="()=>{}" v-model="editPartyForm.card_id" placeholder="请输入身份证" autocomplete="off"></el-input>
                </el-form-item>
              </div>
              <div class="identityInfo-tip">
                <div class="identityInfo-tip-text">
                  您可以手动填写也可以通过身份证识别自动填写
                </div>
                <el-upload
                  v-loading="ocrLoading"
                  class="uploader"
                  action
                  :disabled="!!editPartyForm.id"
                  :show-file-list="false"
                  :auto-upload="false"
                  :on-change="ocrUpload">
                  <div class="identityInfo-tip-btn">
                    <i class="iconfont pxb7-cameras-icon"></i>
                    OCR
                  </div>
                </el-upload>


              </div>
            </el-form-item>
            <!--            <el-form-item label="身份证号" prop="cardid">-->
            <!--            </el-form-item>-->
            <el-form-item label="手机号码" prop="phone">
              <el-input size="small" :disabled="!!editPartyForm.id" class="w-298" @keydown.enter.native.prevent="()=>{}" v-model="editPartyForm.phone" placeholder="请输入手机号码" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="默认签约人" prop="last_use">
              <template>
                <div class="optionsList">
                  <div class="options" :class="editPartyForm.last_use === item.value ? 'optionsSelect' : ''"
                       v-for="(item,index) in lastUseList" :key="index" @click="lastUseChange(item)">
                    {{ item.label }}
                  </div>
                </div>
              </template>
            </el-form-item>
            <el-form-item label="联系地址" prop="country_type">
              <template>
                <div class="optionsList">
                  <div class="options" :class="editPartyForm.country_type === item.value ? 'optionsSelect' : ''"
                       v-for="(item,index) in countryTypeList" :key="index" @click="countryTypeChange(item)">
                    {{ item.label }}
                  </div>
                </div>
              </template>
            </el-form-item>
            <el-form-item label="详细地址" prop="address">
              <div class="domestic" v-if="editPartyForm.country_type == 1">
                <div
                  class="certContractSign-card-body-form-bottom-content-province province"
                >
                  <el-select
                    placeholder="省"
                    class="w-95"
                    v-model="editPartyForm.province"
                    size="small"
                    clearable
                    @change="provinceChange"
                  >
                    <el-option
                      v-for="item in ChinaAddressArea"
                      :key="item.value"
                      :label="item.value"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                  <el-select
                    placeholder="市"
                    class="select w-95"
                    v-model="editPartyForm.city"
                    size="small"
                    clearable
                    @change="cityChange"
                  >
                    <el-option
                      v-for="item in cityList"
                      :key="item.value"
                      :label="item.value"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                  <el-select
                    placeholder="区"
                    class="w-95"
                    v-model="editPartyForm.area"
                    size="small"
                    clearable
                  >
                    <el-option
                      v-for="item in districtList"
                      :key="item.value"
                      :label="item.value"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </div>
                <el-input
                  placeholder="请输入详细地址"
                  class="certContractSign-card-body-form-bottom-content-address w-298"
                  size="small"
                  v-model="editPartyForm.address"
                  maxlength="30"
                  @keydown.enter.native.prevent="()=>{}"
                ></el-input>
              </div>
              <div class="abroad" v-else>
                <el-select placeholder="国家" size="small" class="abroad-select w-298"
                           v-model="editPartyForm.country_code">
                  <el-option
                    v-for="(item, index) in countryList"
                    :key="item.en + index"
                    :label="item.name"
                    :value="item.tel"
                  >
                  </el-option>
                </el-select>
                <el-input
                  placeholder="请输入详细地址"
                  class="certContractSign-card-body-form-bottom-content-address w-298"
                  size="small"
                  maxlength="50"
                  v-model="editPartyForm.address"
                  @keydown.enter.native.prevent="()=>{}"
                ></el-input>
              </div>
            </el-form-item>
          </el-form>
        </div>
        <div class="editPartyDialog-card-foot">
          <!-- <button class="editPartyDialog-card-foot-resBtn" v-prevent-re-click @click="resetEditForm">
            重填
          </button> -->
          <button class="editPartyDialog-card-foot-subBtn" v-prevent-re-click @click="saveEditForm">
            提交
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import ContractingPartyMobile from "./components/ContractingPartyMobile.vue";
import {
  apiContractuserSignVerified,
  apiSellCard,
  appAliyunAuth,
  signatoryAdd,
  signatoryDel,
  signatoryDetails,
  signatoryEdit
} from "../../request/API";
import * as imageConversion from "image-conversion";
// import MonitorKeyboard from './monitorKeyboard.js'

export default {
  name: "buyerInformationMobile",
  props: {},
  components: {
    ContractingPartyMobile
  },
  data() {
    return this.$parent._data
  },
  /*  data() {
      return {
        ruleForm: {
          game_account: '',
          acc_source: 0,
          acc_source_img: '',
          auth_state: "",
          phone: "",
          country_type: 1,
          province: "",
          city: "",
          area: "",
          address:"",
          cert_name: '',
          card_id: '',
          frontIdPhoto: '',
          backIdPhoto: '',
          location: '',
          country_code: '',
        },
        rules: {
          acc_source: {
            required: true,
            message: "请选择账号来源",
            trigger: "blur",
          },
          auth_state: [
            {required: true, validator: this.validatearmsData, trigger: 'blur'},
          ],
          game_account: [
            {required: true,  message: "请输入游戏账号", trigger: 'blur'},
          ],
          phone: [{ required: true, message: "请输入手机号", trigger: "blur" }],
          country_type: [{ required: true, message: "请选择联系地址", trigger: "change" }],
          address: [
            { required: true, message: "请完善联系地址", trigger: "blur" },
            {
              min: 5,
              max: 100,
              message: "请输入5~100个字的准确现住地址",
              trigger: "blur",
            },
          ],
        },
        //登陆方式
        accSourceList: [
          {label: '自己注册', value: '0'},
          {label: '游严选购买', value: '1'},
          {label: '别处购买', value: '5'},
        ],
        //联系地址
        countryTypeList:[
          {label: '国内', value: 1},
          {label: '国外', value: 2},
        ],

        ChinaAddressArea: [],
      }
    },*/
  methods: {
    /**
     * @description: 监听手机软键盘拉起，收起
     * @return {*}
     */
    getKeyboardState() {
      this.monitorKeyboard = new MonitorKeyboard();
      this.monitorKeyboard.onStart();

      // 监听虚拟键盘弹出事件
      this.monitorKeyboard.onShow(() => {
        const element = document.getElementById('card');
        element.style.maxHeight = window.innerHeight + 'px';
      })

      //监听键盘收起的事件
      this.monitorKeyboard.onHidden(() => {
        const element = document.getElementById('card');
        element.style.maxHeight = window.innerHeight + 'px';
      })
    },
    /**
     * 查看商品详情
     */
    selectAccount() {
      this.$parent.selectAccount()
    },
    /**
     * 点击实名认证
     */
    certification() {
      this.$parent.certification()
    },

    /**
     * 省份下拉框选择
     */
    provinceChange(e, flag) {
      this.$parent.provinceChange(e, flag)
    },
    /**
     * 城市下拉框选择
     */
    cityChange(e, flag) {
      this.$parent.cityChange(e, flag)
    },

    /**
     * 上传凭证
     */
    uploadCardBehind(file) {
      this.$parent.uploadCardBehind(file)
    },
    /**
     * 重制表单
     */
    resetInfo() {
      this.$parent.resetInfo()
    },
    /**
     * 表单提交
     */
    saveInfo() {
      this.$parent.saveInfo()
    },
    /**
     * 签约信息表单 打开
     */
    editPartyOpen(item) {
      if (item != '') {
        signatoryDetails({
          client: 'mobile',
          sign_id: item.id
        }).then(res => {
          this.editPartyForm = res.data
          this.editPartyForm.id = item.id
          this.editPartyShow = true
          const { province, city } = this.editPartyForm
          this.cityList = this.ChinaAddressArea.find(item => item.value == province)?.children || []
          this.districtList = this.cityList.find(item => item.value == city)?.children || []
        })
      } else {
        this.editPartyShow = true
      }
      const element = document.getElementById('card');
      window.innerHeight < 722 ? element.style.maxHeight = window.innerHeight - 45 + 'px' : ''
    },
    /**
     * 签约信息表单 关闭
     */
    editPartyClose() {
      this.resetEditForm()
      this.editPartyShow = false
    },
    /**
     * 重制签约信息表单
     */
    resetEditForm() {
      this.editPartyForm = {
        last_use: 1,
        name: '',
        card_id: '',
        country_type: 1,
        country_code: '',
        province: '',
        city: '',
        area: '',
        address: '',
        phone: '',
      }
      this.$nextTick(() => {
        this.$refs.editPartyForm.clearValidate()
      })
    },
    /**
     * 提交签约信息表单
     */
    saveEditForm() {
      if (this.editPartyForm.country_type == 2) {
        this.editPartyForm.province = ''
        this.editPartyForm.city = ''
        this.editPartyForm.area = ''
        if (this.editPartyForm.country_code == '') {
          this.$message({
            message: '请选择国家',
            center: true,
            offset: 200,
            customClass: 'sell-contract-msg'
          })
          return
        }
      } else {
        if (this.editPartyForm.province == '') {
          this.$message({
            message: '请选择省份',
            center: true,
            offset: 200,
            customClass: 'sell-contract-msg'
          })
          return
        } else if (this.editPartyForm.city == '' && this.cityList.length > 0) {
          this.$message({
            message: '请选择城市',
            center: true,
            offset: 200,
            customClass: 'sell-contract-msg'
          })
          return
        } else if (this.districtList.length > 0 && this.editPartyForm.area == '') {
          this.$message({
            message: '请选择区县',
            center: true,
            offset: 200,
            customClass: 'sell-contract-msg'
          })
          return
        }
        this.editPartyForm.country_code = '86'
      }
      if (this.editPartyForm.acc_source != 1) {
        this.editPartyForm.acc_source_img = ''
      }
      this.$refs['editPartyForm'].validate((valid) => {
        if (valid) {
          this.btnLoading = true
          apiContractuserSignVerified(2,{
            cert_name: this.editPartyForm.name,
            cert_id: this.editPartyForm.card_id
          }).then(res => {
            if (this.editPartyForm.id) {
              signatoryEdit({
                client: 'mobile',
                ...this.editPartyForm
              }).then(res => {
                this.$parent.getSignatoryList()
                this.editPartyClose()
                this.btnLoading = false
                setTimeout(this.resetEditForm(), 200)
              }).catch(err => {
                this.btnLoading = false
                this.$message({
                  message: err.msg,
                  center: true,
                  offset: 200,
                  customClass: 'sell-contract-msg'
                })
              })
            } else {
              signatoryAdd({
                client: 'mobile',
                ...this.editPartyForm
              }).then(res => {
                this.$parent.getSignatoryList()
                this.editPartyClose()
                this.btnLoading = false
              }).catch(err => {
                this.btnLoading = false
                this.$message({
                  message: err.msg,
                  center: true,
                  offset: 200,
                  customClass: 'sell-contract-msg'
                })
              })
            }
          }).catch(e=>{
            this.$message({
              message: e.msg,
              center: true,
              offset: 200,
              customClass: 'sell-contract-msg'
            })
          })
        } else {
          this.$message({
            message: '请正确填写相关信息',
            center: true,
            offset: 200,
            customClass: 'sell-contract-msg'
          })
        }
      })
    },

    /**
     * @description: 删除签约人
     * @return {*}
     */
    mydialogBtnClick(delSignId) {
      signatoryDel({
        client: 'mobile',
        sign_id: delSignId
      }).then(res => {
        this.$message({
          message: '删除成功',
          center: true,
          offset: 200,
          customClass: 'sell-contract-msg'
        })
        this.handleClose()
      }).catch(err => {
        this.$message({
          message: '删除失败',
          center: true,
          offset: 200,
          customClass: 'sell-contract-msg'
        })
      })
      this.delPartyShow = false
    },

    /**
     * 选择签约人
     */
    handleActive(id) {
      this.$parent.handleActive(id)
    },
    /**
     * 获取签约人列表
     */
    getSignatoryList() {
      this.$parent.getSignatoryList()
    },
    /**
     * 切换国家
     */
    countryTypeChange(item) {
      this.editPartyForm.country_type = item.value
      this.editPartyForm.country_code = ''
      this.editPartyForm.province = ''
      this.editPartyForm.city = ''
      this.editPartyForm.area = ''
    },
    /**
     * 切换默认签约人
     */
    lastUseChange(item) {
      this.editPartyForm.last_use = item.value
    },

    /**
     * ocr识别
     * @param file
     * @returns {Promise<void>}
     */
    async ocrUpload(file) {
      this.ocrLoading = true
      const isJPG = file.raw.type === 'image/jpeg' || file.raw.type === 'image/png';
      const isLt5M = file.size / 1024 / 1024 < 5;
      if (!isJPG) {
        this.$message({
          message: '上传图片只能是 JPG/PNG 格式!',
          center: true,
          offset: 200,
          customClass: 'sell-contract-msg'
        })
        return
      }
      let newFile = await imageConversion.compressAccurately(file.raw, {
        size: 900,
        type: 'image/jpeg'
      })
      let blob_file = new File([newFile],this.uuid()+".jpeg",{type:file.type,lastModified: Date.now()})
      let formData = new FormData()
      formData.append('file', blob_file)
      apiSellCard(2,formData).then(resp => {
        appAliyunAuth(2,{
          url: resp.data.url
        }).then(res => {
          // if(this.form.card_id!=''&&this.form.card_id!=null&&this.form.card_id!=res.data.cert_id){
          //   this.$message({
          //     message: '上传身份证与法大大实名不一致',
          //     center: true,
          //     offset: 200,
          //     customClass: 'sell-contract-msg'
          //   })
          //   this.loading = false
          //   this.frontIdPhoto_url = ''
          //   return
          // } else {
          this.editPartyForm.name = res.data.cert_name
          this.editPartyForm.card_id = res.data.cert_id
          if(this.editPartyForm.name == '' || this.editPartyForm.card_id == ''){
            this.$message({
              message: '验证失败，请重新上传',
              center: true,
              offset: 200,
              customClass: 'sell-contract-msg'
            })
          } else {
            this.$message({
              message: '验证通过',
              center: true,
              offset: 200,
              customClass: 'sell-contract-msg'
            })
          }
          this.ocrLoading = false
          // }
        }).catch(err => {
          this.$message({
            message: err.msg,
            center: true,
            offset: 200,
            customClass: 'sell-contract-msg'
          })
          this.ocrLoading = false
        })
      }).catch(err => {
        this.$message({
          message: err.msg,
          center: true,
          offset: 200,
          customClass: 'sell-contract-msg'
        })
        this.ocrLoading = false
      })
    },

    /**
     * @description: 生成唯一标识
     * @return {*}
     */
    uuid() {
      let s = [];
      let hexDigits = "0123456789abcdef";
      for (let i = 0; i < 36; i++) {
        s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
      }
      s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
      s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
      s[8] = s[13] = s[18] = s[23] = "-";
      let uuid = s.join("");
      return uuid;
    },
  },
  watch: {},
  created() {

  },
  // mounted(){
  //   this.getKeyboardState();
  // },
  // beforeDestroy(){
  //   this.monitorKeyboard.onEnd();
  // },
}
</script>

<style scoped lang="less">
.buyerInformationMobile {
  background-image: url("../../assets/image/Contract/sellerInformationMobile/head.png");
  background-repeat: no-repeat;
  background-size: 100%;
  background-color: #f6f6f6;
  width: 100vw;
  min-height: calc(100vh - 80px);
  padding-bottom: 80px;

  &-head {
    height: 159px;
    padding: 0 40px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;

    &-title {
      font-size: 18px;
      font-family: PingFang SC-Semibold, PingFang SC;
      font-weight: 600;
      color: #333333;
      margin: 0 0 6px;
    }

    &-orderNum {
      font-size: 12px;
      font-family: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
      color: #666666;
    }
  }

  &-body {
    padding: 0 10px;

    &-card {
      padding: 20px;
      background: #FFFFFF;
      border-radius: 4px 4px 4px 4px;
      margin: 0 0 20px;

      &-title {
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 16px;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #333333;

        &-tip {
          font-size: 12px;
          font-family: PingFang SC-Regular, PingFang SC;
          font-weight: 400;
          color: #F08721;
          display: flex;
          align-items: center;

          i {
            font-size: 16px;
            margin: 0 2px 0 0;
          }

          .arrow-right {
            font-size: 12px;
            margin: 0 0 0 2px;
          }
        }
      }

      .agencyInfo {
        flex-direction: column;
        align-items: flex-start;
        position: relative;

        .buyerInformationMobile-body-card-title-tip {
          margin: 4px 0 0;
        }

        .addParty {
          font-size: 14px;
          font-family: PingFang SC-Regular, PingFang SC;
          font-weight: 400;
          color: #F08C2B;
          position: absolute;
          right: 0;
        }
      }

      &-form {
        margin: 12px 0 0;
        position: relative;

        .auth_state {
          flex-direction: row !important;
          align-items: center;

          /deep/ .el-form-item__content {
            width: 100%;
            text-align: right;
          }

          /deep/ .el-form-item__label {
            margin: 0;
          }

          .real {
            font-size: 12px;
            font-family: PingFang SC-Medium, PingFang SC;
            font-weight: 500;
            color: #F0EDE8;
          }
        }

        .province {
          /deep/ .el-select {
            width: calc((100% - 7px * 3) / 3);
            margin: 0 7px 5px 0;
          }
        }

        .abroad {
          /deep/ .el-select {
            width: 100%;
            margin: 0 7px 5px 0;
          }
        }

        .address {
          margin: 5px 0 0;
        }

        .sign-tip{
          position: absolute;
          right: 0;
          top: 0;
          font-size: 12px;
          font-family: PingFang SC-Regular, PingFang SC;
          font-weight: 400;
          color: #F08721;
        }

      }
    }

  }

  &-foot {
    padding: 15px 20px 25px;
    background: rgba(255, 255, 255, 0.95);
    position: fixed;
    bottom: 0px;
    left: 0px;
    width: calc(100vw - 20px * 2);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 2;

    button {
      border: none;
    }

    &-resBtn {
      width: 76px;
      height: 38px;
      border-radius: 4px 4px 4px 4px;
      opacity: 1;
      border: 1px solid #F08C2B !important;
      font-size: 16px;
      font-family: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
      color: #F08C2B;
      text-align: center;
      margin: 0 12px 0 0;
      background-color: #FFFFFF;
    }

    &-subBtn {
      width: 239px;
      height: 40px;
      background: #F08C2B;
      border-radius: 4px 4px 4px 4px;
      font-size: 16px;
      font-family: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
      color: #FFFFFF;
      line-height: 40px;
      text-align: center;
    }
  }

}

.optionsList {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;

  .options {
    width: 30%;
    height: 40px;
    line-height: 40px;
    background: #F6F6F6;
    border-radius: 4px 4px 4px 4px;
    font-size: 12px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
    text-align: center;
    margin: 0 8px 5px 0;

  }

  .optionsSelect {
    background: #FFF8EF;
    font-family: PingFang SC-Medium, PingFang SC;
    color: #F08C2B;
    position: relative;
    overflow: hidden;

    &::before {
      content: "";
      position: absolute;
      width: 7px;
      height: 4px;
      background: transparent;
      bottom: 4px;
      right: 2px;
      border: 1px solid #fff;
      border-top: none;
      border-right: none;
      -webkit-transform: rotate(-55deg);
      transform: rotate(-55deg);
      z-index: 1;
    }

    &::after {
      content: "";
      position: absolute;
      bottom: 0px;
      right: 0px;
      border-bottom: 18px solid #f08c2b;
      border-left: 18px solid transparent;
    }
  }

  .filetypeOptions {
    width: 45%;
    height: 29px;
    line-height: 29px;
    margin: 0;
  }
}

.editPartyDialog {
  background: rgba(0, 0, 0, 0.5);
  width: 100vw;
  height: 100vh;
  position: fixed;
  bottom: 0px;
  display: flex;
  align-items: flex-end;
  z-index: 3;

  &-card {
    width: calc(100% - 20px * 2);
    //height: 620px;
    background: #FFFFFF;
    border-radius: 4px 4px 0px 0px;
    padding: 20px 20px 25px 20px;
    overflow-y: scroll;

    &-head {
      margin: 0 0 10px;
      position: relative;

      .title {
        font-size: 16px;
        font-family: PingFang SC-Semibold, PingFang SC;
        font-weight: 600;
        color: #333333;
        text-align: center;
      }

      .close {
        position: absolute;
        top: -6px;
        right: 0;
        color: #1d363d;
        font-size: 25px;

        /deep/ .el-icon-close {
          font-weight: 600;
        }
      }
    }

    &-body {
      /deep/ .el-form-item {
        margin: 0 0 20px !important;
      }

      .identityInfo {
        &-box {
          background-color: #f6f6f6;
          border-radius: 4px 4px 4px 4px;

          &-item {
            margin: 0 !important;

            /deep/ .el-form-item__content {
              display: flex;
              flex-direction: row;
              align-items: center;

              .el-form-item__error {
                top: 10px;
                right: 10px;
                border: none;
                left: unset;
              }

              input {
                padding: 0;
                border: none;
              }
            }

            padding: 0 19px 0 16px;

            &-label {
              width: 80px;
              font-size: 14px;
              font-family: PingFang SC-Regular, PingFang SC;
              font-weight: 400;
              color: #666666;
              flex-shrink: 0;
            }

          }

          &-item:first-of-type {
            /deep/ .el-form-item__content {
              input {
                border-bottom: 1px solid #ededed;
              }
            }
          }
        }

        &-tip {
          display: flex;
          align-items: center;
          justify-content: space-between;
          line-height: 20px;
          margin: 9px 0 0;

          &-text {
            font-size: 11px;
            font-family: PingFang SC-Regular, PingFang SC;
            font-weight: 400;
            color: #C4C4C4;
          }

          &-btn {
            width: 72px;
            height: 20px;
            line-height: 20px;
            background: #FFAA5F;
            border-radius: 4px 4px 4px 4px;
            text-align: center;
            color: #FFFFFF;
            font-size: 12px;

            i {
            }
          }
        }
      }

      .province {
        /deep/ .el-select {
          width: calc((100% - 7px * 3) / 3);
          margin: 0 7px 5px 0;
        }
      }

      .abroad {
        /deep/ .el-select {
          width: 100%;
          margin: 0 7px 5px 0;
        }
      }
    }

    &-foot {
      margin: 32px 0 0;
      padding-top: 15px;
      border-top: 1px solid #F6F6F6;
      //padding: 15px 23px 25px;
      background: rgba(255, 255, 255, 0.95);
      //position: fixed;
      //bottom: 0px;
      //left: 0px;
      width: calc(100vw - 20px * 2);
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 2;

      button {
        border: none;
      }

      &-resBtn {
        width: 76px;
        height: 38px;
        border-radius: 4px 4px 4px 4px;
        opacity: 1;
        border: 1px solid #F08C2B !important;
        font-size: 16px;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #F08C2B;
        text-align: center;
        margin: 0 12px 0 0;
        background-color: #FFFFFF;
      }

      &-subBtn {
        width: 239px;
        height: 40px;
        background: #F08C2B;
        border-radius: 4px 4px 4px 4px;
        font-size: 16px;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
        line-height: 40px;
        text-align: center;
      }
    }
  }
}


/deep/ .el-form-item {
  display: flex;
  flex-direction: column;
  margin: 0 0 12px;

  .el-form-item__label {
    line-height: 20px;
    height: 20px;
    width: auto;
    text-align: left;
    flex-shrink: 0;
    margin: 0 0 10px;
    font-family: PingFang SC-Medium, PingFang SC;
    font-weight: 500;
    color: #666666;
  }
}

/deep/ .el-input {
  .el-input__inner {
    background: #F6F6F6;
    border-color: #F6F6F6;
    height: 40px;
    line-height: 40px;
  }
}


.uploadimg-box {
  &-btn {
    /deep/ .el-upload {
      background-color: #FFFFFF;
      border: 1px dimgray #DEE3EC;
    }

    * {
      color: #DEE3EC;
    }

    &-img {
      width: 100%;
      object-fit: contain;
    }
  }

  &-text {
    margin: 12px 0 0;
    font-size: 12px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
    line-height: 17px;

    span {
      color: #F56B6C;
    }
  }
}

</style>
<style scoped lang="less">
.buyerInformationMobile {
  background-image: none;
  background-color: var(--bg-page, #F7F5F2);
  min-height: 100vh;
  padding-bottom: 0;

  &-head {
    height: 278px;
    box-sizing: border-box;
    padding: 63px 0 0;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
    position: relative;
    background: #D8D2CA;

    &-content {
      width: 1200px;
      margin: 0 auto;
    }

    &-title {
      width: auto;
      margin: 0 0 13px 20px;
      font-size: 24px;
      line-height: 30px;
      color: #FFFFFF;
    }

    &-orderNum {
      width: auto;
      margin: 0 0 0 20px;
      font-size: 20px;
      line-height: 28px;
      color: rgba(255, 255, 255, 0.88);
    }

    .logo {
      position: absolute;
      left: calc(50% + 350px);
      margin-top: 9px;
      width: 250px;
      height: 58px;
      box-sizing: border-box;
      padding: 8px 18px;
      border-radius: 4px;
      background-color: var(--bg-card, #FFFFFF);
      background-image: url("~@/assets/logo/logo_horizontal.svg");
      background-repeat: no-repeat;
      background-position: center;
      background-size: calc(100% - 36px) calc(100% - 16px);
    }
  }

  &-body {
    position: relative;
    top: -123px;
    width: 1200px;
    margin: 0 auto;
    padding: 0 0 57px;

    &-card {
      box-sizing: border-box;
      padding: 80px;
      background: var(--bg-card, #FFFFFF);
      border-radius: 4px;
      box-shadow: var(--shadow-card, 0 8px 24px rgba(26, 29, 36, 0.08));

      &-title {
        color: var(--text-main, #111827);

        &-tip {
          color: var(--text-secondary, #5A5F6B) !important;

          i {
            color: var(--warning, #F59E0B);
          }
        }
      }

      .agencyInfo {
        .addParty {
          color: var(--primary, #FF5A1F);
        }
      }

      &-form {
        .sign-tip {
          color: var(--primary, #FF5A1F);
        }

        .province {
          /deep/ .el-select {
            width: calc((100% - 30px) / 3);
            margin: 0 15px 15px 0;
          }
        }

        .address {
          margin-top: 0;
        }
      }
    }
  }

  &-foot {
    position: relative;
    left: auto;
    bottom: auto;
    width: 80%;
    box-sizing: border-box;
    margin: -270px auto 0;
    padding: 0 0 57px;
    border-top: 0;
    background: transparent;
    display: flex;
    justify-content: center;

    button {
      width: 250px;
      height: 50px;
      box-sizing: border-box;
      padding: 0;
      line-height: 1;
      font-family: inherit;
      font-size: 18px;
      font-weight: 500;
      display: inline-flex !important;
      align-items: center;
      justify-content: center;
      text-align: center;
      cursor: pointer;
      transition: all .2s ease;
      border-radius: 4px;

      &:disabled {
        cursor: not-allowed;
        opacity: .68;
      }
    }

    &-resBtn {
      color: var(--text-main, #1A1D24);
      border: 1.5px solid var(--bg-dark, #1A1D24) !important;
      background: transparent;

      &:hover,
      &:focus {
        color: var(--text-main, #1A1D24);
        border-color: var(--bg-dark, #1A1D24) !important;
        background: var(--bg-tag, #F0EDE8);
      }

      &:active {
        border-color: var(--bg-dark, #1A1D24) !important;
        background: var(--bg-tag, #F0EDE8);
      }
    }

    &-subBtn {
      margin-left: 30px;
      border: 0;
      background: var(--primary, #FF5A1F);
      color: #FFFFFF;

      &:only-child {
        margin-left: 0;
      }

      &:hover,
      &:focus {
        color: #FFFFFF;
        border: 0;
        background: var(--primary-hover, #E84A12);
        box-shadow: none;
      }

      &:active {
        color: #FFFFFF;
        background: var(--primary-hover, #E84A12);
        box-shadow: none;
      }

      &:disabled {
        color: rgba(255, 255, 255, 0.75);
        border: 0;
        background: var(--primary, #FF5A1F);
        box-shadow: none;
        opacity: .68;
      }
    }
  }

  @media screen and (max-width: 1300px) {
    &-head {
      &-content {
        width: 95vw;
      }

      .logo {
        left: auto;
        right: 2.5vw;
      }
    }

    &-body {
      width: 95vw;
    }
  }

  @media screen and (max-width: 900px) {
    min-height: calc(100vh - 80px);
    padding-bottom: 80px;

    &-head {
      height: 140px;
      padding: 23px 24px 0;
      flex-direction: column;
      align-items: flex-start;
      position: relative;

      &-content {
        width: auto;
        margin: 0;
      }

      &-title {
        width: auto;
        margin: 0 0 6px;
        font-size: 18px;
        line-height: normal;
      }

      &-orderNum {
        width: auto;
        margin: 0;
        font-size: 12px;
        line-height: normal;
      }

      .logo {
        position: absolute;
        top: 23px;
        left: auto;
        right: 24px;
        transform: none;
        z-index: 1;
        margin-top: 0;
        width: 139px;
        height: 33px;
        box-sizing: border-box;
        padding: 4px 10px;
        border-radius: 4px;
        background-size: calc(100% - 20px) calc(100% - 8px);
      }
    }

    &-body {
      top: -53px;
      width: auto;
      margin: 0;
      padding: 0 12px;

      &-card {
        padding: 20px;

        &-form {
          .province {
            /deep/ .el-select {
              width: calc((100% - 7px * 3) / 3);
              margin: 0 7px 5px 0;
            }
          }

          .address {
            margin-top: 5px;
          }
        }
      }
    }

    &-foot {
      position: fixed;
      left: 0;
      bottom: 0;
      width: 100vw;
      margin: 0;
      padding: 15px 20px 25px;
      border-top: 1px solid var(--border-soft, #E8E4DE);
      background: rgba(255, 255, 255, 0.95);

      button {
        height: 40px;
        border-radius: 4px;
        font-size: 16px;
      }

      &-resBtn {
        width: 76px;
      }

      &-subBtn {
        width: 239px;
        margin-left: 12px;

        &:only-child {
          margin-left: 0;
        }
      }
    }
  }
}

.optionsList {
  .optionsSelect {
    color: var(--primary, #FF5A1F);
    background: var(--primary-soft, #FCEDE5);

    &::after {
      border-bottom-color: var(--primary, #FF5A1F);
    }
  }
}

.editPartyDialog {
  align-items: center;
  justify-content: center;

  &-card {
    width: 520px;
    max-height: 80vh;
    box-sizing: border-box;
    border-radius: 4px;
    background: var(--bg-card, #FFFFFF);
    box-shadow: var(--shadow-card, 0 8px 24px rgba(26, 29, 36, 0.08));

    &-head {
      .title {
        color: var(--text-main, #111827);
      }

      .close {
        color: var(--text-secondary, #5A5F6B);
      }
    }

    &-body {
      .identityInfo {
        &-box {
          background: var(--bg-section, #F7F5F2);
        }

        &-tip {
          &-btn {
            background: var(--primary, #FF5A1F);
          }
        }
      }
    }

    &-foot {
      width: 100%;
      border-top-color: var(--border-soft, #E8E4DE);

      &-resBtn {
        width: 120px;
        height: 40px;
        box-sizing: border-box;
        padding: 0;
        line-height: 1;
        border-radius: 4px;
        font-family: inherit;
        display: inline-flex !important;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        color: var(--text-main, #1A1D24);
        border: 1.5px solid var(--bg-dark, #1A1D24) !important;
        background: transparent;
        transition: all .2s ease;

        &:hover,
        &:focus {
          color: var(--text-main, #1A1D24);
          border-color: var(--bg-dark, #1A1D24) !important;
          background: var(--bg-tag, #F0EDE8);
        }

        &:active {
          border-color: var(--bg-dark, #1A1D24) !important;
          background: var(--bg-tag, #F0EDE8);
        }
      }

      &-subBtn {
        width: 180px;
        height: 40px;
        box-sizing: border-box;
        padding: 0;
        line-height: 1;
        border-radius: 4px;
        font-family: inherit;
        display: inline-flex !important;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        border: 0;
        background: var(--primary, #FF5A1F);
        color: #FFFFFF;
        transition: all .2s ease;

        &:hover,
        &:focus {
          color: #FFFFFF;
          border: 0;
          background: var(--primary-hover, #E84A12);
          box-shadow: none;
        }

        &:active {
          color: #FFFFFF;
          background: var(--primary-hover, #E84A12);
          box-shadow: none;
        }
      }
    }
  }

  @media screen and (max-width: 900px) {
    align-items: flex-end;
    justify-content: center;

    &-card {
      width: calc(100% - 20px * 2);
      max-height: none;
      border-radius: 4px 4px 0 0;

      &-foot {
        width: calc(100vw - 20px * 2);

        &-resBtn {
          width: 76px;
          height: 38px;
          border-radius: 4px;
        }

        &-subBtn {
          width: 239px;
          height: 40px;
          border-radius: 4px;
        }
      }
    }
  }
}

/deep/ .el-input {
  .el-input__inner {
    background: var(--bg-section, #F7F5F2);
    border-color: var(--border-soft, #E8E4DE);

    &:focus {
      border-color: var(--primary, #FF5A1F);
      box-shadow: none;
    }
  }
}

.uploadimg-box {
  &-btn {
    /deep/ .el-upload {
      border-color: var(--border-soft, #E8E4DE);
      background: var(--bg-section, #F7F5F2);
    }
  }
}
</style>
